import { Injectable, ViewChild } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthWebService } from 'app/services/authweb.service';
import { SocialAuthService, SocialUser } from "angular12-social-login";
import { IdleManagerService } from "app/services/idle-manager.service";
import { BsModalService, ModalDirective } from "ngx-bootstrap/modal";

@Injectable({
  providedIn: 'root'
})
export class InternalRouteGuard implements CanActivate {
  isInternalUser: boolean = false;
  @ViewChild("childModal", { static: true }) childModal: ModalDirective;

  constructor(private router: Router , private authWebService: AuthWebService 
    ,    private authService: SocialAuthService, private idleSrvc: IdleManagerService,) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
     // Replace this with your condition.
    if (!this.authWebService.userData.Roles[0].IsExternalRole) {
      this.isInternalUser = true;
    }

    if (this.isInternalUser) {
      return true; // Allow access to the route.
    } else {
      this.router.navigate(['/home']); // Replace '/unauthorized' with the route you want to navigate when access is denied.
      this.logout();
      return false; // Block access to the route.
    }
  }

  logout() {
    this.authService.signOut();
    this.childModal.hide();
    this.idleSrvc.setLoggedIn(false);
    this.authWebService.logout();

  }
}
